import React, { FC, ReactNode, useRef, useState, useEffect , useMemo} from "react";
import { Menu, Dropdown, Button, Row, Input, DatePicker, Popover, Badge, Tooltip, Spin } from "antd";
import { Drawer } from "antd";
import moment from "moment";
import { debounce, find, get, pickBy } from "lodash";

import Logo from "@assets/logo.png";
import Header from "@components/header";
import Sidebar from "@components/sidebar";
import ActionBar from "@components/action-bar";
import Notes from "@components/drawerNotes/drawerNotes";
import DrawerCalendar from "@components/drawerCalendar";
import { MEMBERS_DETAILS_SCREEN_TITLE, notificationsDrawerFilterOptions, rightDrawerActions } from "@utils/constants";
import useSession from "@utils/useSession";
import Notifications from "@components/drawerNotifications";
import "./default.scss";
import membersService from "@services/members.service";
//import classNames from "classnames";
import Alerts from "@components/drawerAlerts";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import CmContactMatrixModalReadMode from "@components/hospitalMapping/cmContactMatrixModalReadMode/CmContactMatrixModalReadMode";
import { dateFormatConfig } from "@utils/constants";
import { centricClientCheck, formatDownloadFileNameDate, getClientName, milleniumClientCheck } from "@utils/helpers";
import ScrollToTopButton from "@components/scrollToTop/scrollButton";
import Outreaches from "@components/drawerOutreaches/drawerOutreaches";
import { EntryFilter } from "@components/drawerOutreaches/NewOutreach";
import { useOutReaches } from "@utils/customHooks";
import Icon from "@assets/icon_config";
import CustomTooltip from "@pages/tool-tip";
import { RemindersProvider } from "@components/drawerCalendar/useReminders";
import { useMembersContext } from "@pages/members/useMembers";
import { CadenceContext, CadenceContextProvider } from "@components/drawerOutreaches/useCadence";

import reportService from "@services/report.service";
import { useLocation } from "react-router-dom";
import { useMemberListStore } from "@stores/useMemberListStore";
import { DownloadOutlined } from "@ant-design/icons";
import exportToExcel from "@utils/applyExcelStyle";
import { Spinner } from "@components/healthemSpinner/healthemSpinner";
const defaultDateFormat = getClientName() ? dateFormatConfig.get(getClientName())["defaultDateFormat"] : "MM-DD-YYYY";

export type LayoutProps = {
  children: ReactNode;
  members?: any;
  updateMembers?: any;
  notifications?: any;
  newNotificationFlag?: boolean;
  setNewNotificationFlag?: any;
  noPadding?: any;
  updateStatus?: any;
  defaultTab?: any;
  setDefaultTab?:any
};

const DrawerContent = ({selectedDrawerOption , members , updateMembers , searchValue , filterValue , filterStartDate , filterEndDate , showRightActionBar , 
  updateStatus , rightDrawerCloseHandler , globalEntryFilterData , fetchOutReaches , setOutReachesData , outReachesLoader , outReachesData , datefilter, defaultTab, setDefaultTab} : any) => {
  switch (!!selectedDrawerOption) {
    case selectedDrawerOption === find(rightDrawerActions , (action) => action.id === 'Alerts')?.id:
      return <Alerts members={members} updateMembers={updateMembers} searchValue={searchValue} filterValue={filterValue} filterStartDate={filterStartDate} filterEndDate={filterEndDate} showRightActionBar={showRightActionBar}/>;
    case selectedDrawerOption === find(rightDrawerActions , (action) => action.id === 'Notes')?.id:
      return (
        <Notes
          members={members}
          updateMembers={updateMembers}
          searchValue={searchValue}
          filterValue={filterValue}
          updateStatus={updateStatus}
          filterStartDate={filterStartDate}
          filterEndDate={filterEndDate}
          defaultTab={defaultTab}
          setDefaultTab={setDefaultTab}
          rightDrawerCloseHandler={rightDrawerCloseHandler}
        />
      );
    case selectedDrawerOption === find(rightDrawerActions , (action) => action.id === 'Reminders')?.id:
      return <DrawerCalendar members={members} updateMembers={updateMembers} updateStatus={updateStatus} rightDrawerCloseHandler={rightDrawerCloseHandler} />;
    case selectedDrawerOption === find(rightDrawerActions , (action) => action.id === 'Recorded Entries')?.id:
      return <Outreaches members={members} outReachesLoader={outReachesLoader} outReachesData={outReachesData} globalEntryFilterData={globalEntryFilterData} fetchOutReaches={fetchOutReaches} setOutReachesData={setOutReachesData} searchValue={searchValue} />;
    case selectedDrawerOption === find(rightDrawerActions , (action) => action.id === 'Notification')?.id:
      return <Notifications searchString={searchValue} filter={datefilter} />;
    default:
      return <>Error</>;
  }
};

const Layout: FC<LayoutProps> = ({ children, members, updateMembers, notifications, newNotificationFlag, setNewNotificationFlag, noPadding, updateStatus }: LayoutProps) => {
  const { RangePicker } = DatePicker;

  const session = useSession();

  const {sidebarExpand , handleSidebar} = useMembersContext();

  const currentScreen = useGlobalInformationStore((state) => state.currentScreen);

  const [showRightActionBar, rightActionbarHandler] = useState(false);
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [searchValue, setSearchVal] = useState("");
  const [searchValueCopy , setSearchValueCopy] = useState('');
  const [filterValue, setFilterVal] = useState("");
  const [selectedDrawerOption, actionsDrawerHandler] = useState(find(rightDrawerActions , (action) => action.id === 'Alerts')?.id);
  const [datefilter, setdatefilter] = useState("all");
  // const [notificationSearchQuery, setnotificationSearchQuery] = useState("");
  const [filterStartDate, setFilterStartDate] = useState<any>(null);
  const [filterEndDate, setFilterEndDate] = useState<any>(null);
  const [isDateFilterApplied, setDateFilterApplied] = useState<boolean>(false);
  const [popOverclicked, setPopOverClicked] = useState<boolean>(false);
  const [showEntryFilter , setShowEntryFilter] = useState<boolean>(false);
  const {outReachesLoader , outReachesData , fetchOutReaches , setOutReachesData} = useOutReaches();
  const [globalEntryFilterData , setGlobalEntryFilterData] = useState<any>({});
  const [defaultTab, setDefaultTab] = useState("1");
  const [downloadLoader, setDownloadLoader] = useState(false)
  const notesData = useMemberListStore((state) => state.notesData);
  const setNotesData = useMemberListStore((state) => state.setNotesData);
  const location = useLocation();
  const isGlobalEntryFilterApplied =  useMemo(() => {
    const appliedEntryFilters =  pickBy(globalEntryFilterData , (ef) => ef.value);

    return Object.values(appliedEntryFilters).length > 0;
  },[globalEntryFilterData]);

  const inputRef = useRef<any>(null);

  const markAllNotificationsAsRead = () => {
    membersService.markAllNotificationsAsRead().subscribe({
      next: (v) => {
        console.log(v);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  const rightActionClickHandler = (data: any) => {
    if (data.id === "Notification") {
      setNewNotificationFlag(false);
      markAllNotificationsAsRead();
    }
    actionsDrawerHandler(data.id);
    rightActionbarHandler(true);
    setShowSearchBox(false);
  };

  const rightDrawerCloseHandler = () => {
    rightActionbarHandler(false);
    setPopOverClicked(false);
    setdatefilter("all");
    setSearchVal("");
    setFilterStartDate("");
    setFilterEndDate("");
    setFilterVal("");
    setFilterStartDate(null);
    setFilterEndDate(null);
    setDateFilterApplied(false);
    setGlobalEntryFilterData({});
    setShowEntryFilter(false);
    handleSidebar(false);
    setDefaultTab("1");
    setNotesData(null);
    setSearchValueCopy('');
  };


  const openSearch = () => {
    setShowSearchBox(true);
    // document.getElementsByClassName("ant-drawer-title")[0].classList.add("remove-title");
    // setSearchVal("");
  };

  const closeSearch = () => {
    setShowSearchBox(false);
    document.getElementsByClassName("ant-drawer-title")[0].classList.remove("remove-title");
  };

  const onSearch = (e: any) => {
    setSearchVal(e.target.value)
  };

  const searchFilterValue = debounce(onSearch,500);

  // Commented this code after the new calender filter is applied.
  // const onFilterChange = (criteria: any) => {
  //   setFilterVal(criteria);
  // };

  // Commented this code after the new calender filter is applied.
  // const noteDrawerFilterOptions = () => {
  //   return (
  //     <Menu>
  //       {notesDrawerFilterOptions?.map((item, index) => {
  //         return (
  //           <Menu.Item key={index}  className={`noteTimefilter-option ${item?.value === "0" ? "clear-filter" : ""}`}>
  //             <Button type="link" className="noteTimeFilter-action" onClick={(e) => onFilterChange(item?.value)}>
  //               {item.label}
  //             </Button>
  //           </Menu.Item>
  //         );
  //       })}
  //     </Menu>
  //   );
  // };

  /*const pageviewWrapperClassName = classNames( "pageviewWrapper", {
    "pageviewWrapper--no-padding": noPadding
  } )*/
  useEffect(() => {
    if(showSearchBox){
    inputRef?.current?.focus();
    }
    else {
    inputRef?.current?.blur();
    }
  },[showSearchBox])
  
  const notificationDrawerFilterOptions = () => {
    return (
      <Menu>
        {notificationsDrawerFilterOptions?.map((item, index) => {
          return (
            <Menu.Item
              key={index}
              className={`noteTimefilter-option`}
              onClick={() => {
                setdatefilter(item.value);
              }}
            >
              <Button type="link" className={`noteTimeFilter-action ${datefilter === item.value ? "noteTimefilter-option__selected" : ""}`}>
                {item.label}
              </Button>
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };

  const rangeChange = (range: any) => {
    const startDate = range && range.length > 0 ? range[0].format("YYYY-MM-DD") : "";
    const endDate = range && range.length > 0 ? range[1].format("YYYY-MM-DD") : "";

    if (startDate !== "" && endDate !== "") {
      setDateFilterApplied(true);
    }

    setFilterStartDate(startDate);
    setFilterEndDate(endDate);
  };

  const handlePopOverClose = (state: any) => {
    if (!state) {
      setPopOverClicked(false);
    }
  };

  function resetNotesFilter(){
    setFilterStartDate(null);
    setFilterEndDate(null);
    setDateFilterApplied(false);
    setSearchVal('');
    setSearchValueCopy('');
  }

  function resetOutreachesFilter() {
    setGlobalEntryFilterData({});
    fetchOutReaches({});
    setSearchVal('');
    setSearchValueCopy('');
  }

  function resetNotificationFilter(){
    setdatefilter("all")
    setSearchVal('');
    setSearchValueCopy('');
  }

  const isMemberDetails = useMemo(() => {
    return location.pathname === "/member-detail";
  }, [location.pathname]);

  const currentMember = membersService?.getCurrentMember;
  const memberId = useMemo(() => (isMemberDetails ? currentMember?.patient_id : ""), [isMemberDetails, currentMember]);

  const stripHtmlTags = (html: any) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };
  
  function downloadNotesReport() {
    setDownloadLoader(true);
    reportService.downloadNotesReport(isMemberDetails, memberId).subscribe({
      next: (v) => {
        setDownloadLoader(false);
        const { data } = v.data;
        const columns = Object.keys(data[0]).map((key) => ({
          tableHeaderName: key,
          dataIndex: key.replace(/\s+/g, ""),
        }));
  
        const notesData = data.map((item: any) =>
          Object.fromEntries(
            Object.entries(item).map(([key, value]) => [
              key.replace(/\s+/g, ""),
              key === "NOTES" ? stripHtmlTags(value)
              : key === "CREATED DATE"
              ? moment(value as string)?.utc()?.format(dateFormatConfig.get(getClientName())["reminderDateActualFormat"])
              : value,
            ])
          )
        );
  
        exportToExcel({
          filename: `Notes Report ${formatDownloadFileNameDate(new Date())}.xlsx`,
          sheets: [
            {
              sheetName: "Notes Report",
              columns: columns.map((col) => ({
                header: col.tableHeaderName,
                key: col.dataIndex,
              })),
              data: notesData,
              styles: { headerBold: true },
            },
          ],
        });
      },
      error: (e) => {
        setDownloadLoader(false);
        console.error("Error fetching data:", e);
      },
    });
  }

  const selectedDrawer = rightDrawerActions.find(i => i.id === selectedDrawerOption);
  const isAlertSelected = selectedDrawerOption === find(rightDrawerActions, (action) => action.id === "Alerts")?.id
  const isNotesSelected = selectedDrawerOption === find(rightDrawerActions, (action) => action.id === "Notes")?.id
  const isOutreachSelected = selectedDrawerOption === find(rightDrawerActions, (action) => action.id === "Recorded Entries")?.id
  const isNotificationSelected = selectedDrawerOption === find(rightDrawerActions, (action) => action.id === "Notification")?.id
  
  return (
    <>
    
    <CadenceContextProvider rightDrawerCloseHandler={rightDrawerCloseHandler}>
      <Header actionClickHandler={rightActionClickHandler} newNotificationFlag={newNotificationFlag} logo={Logo} companyName="Company Name" userName={session?.user?.firstName} />
      <Row>
        <div className="sidebarWrapper">
          <Sidebar />
        </div>
        <div className={`pageviewWrapper`}>{children}</div>
        <div className="rightActionBarWrapper">
          <ActionBar
            newNotificationFlag={newNotificationFlag}
            actionClickHandler={rightActionClickHandler}
            members={currentScreen === MEMBERS_DETAILS_SCREEN_TITLE ? (members?.length > 0 ? members[0]?.patient_id : undefined) : members}
          />
        </div>
      </Row>

      <Drawer
        destroyOnClose={true}
        title={
          showSearchBox ? (
            isAlertSelected || isNotesSelected || isNotificationSelected || isOutreachSelected ? (
              <Input
                placeholder={isAlertSelected || isNotesSelected ? "Type to search..." : isNotificationSelected ? "Search from notifications, members..." : "Search from Entries, members..."}
                className="notesDrawerSearch"
                ref={inputRef}
                value={searchValueCopy}
                onChange={(e) => {
                  setSearchValueCopy(e.target.value);
                  searchFilterValue(e);
                }}
                onPressEnter={closeSearch}
                bordered={false}
                style={{ width: "100%" }}
                prefix={<i className="icon icon-search"></i>}
              />
            ) : null
          ) : selectedDrawerOption !== find(rightDrawerActions, (action) => action.id === "Reminders")?.id ? (
            selectedDrawerOption
          ) : null
        }
        placement="right"
        closable={false}
        onClose={rightDrawerCloseHandler}
        visible={showRightActionBar}
        key="right"
        className={`right-drawer ${selectedDrawer?.drawerClassName}`}
        width={sidebarExpand ? "100vw" : isAlertSelected ? "490" : "480"}
        bodyStyle={isAlertSelected ? { padding: "0px 0px 10px 10px" } : { paddingTop: 0 }}
        extra={
          <>
            {(isAlertSelected || isNotesSelected) && (
              <>
                {!showSearchBox && <i className="icon icon-search noteDrawer-action" onClick={openSearch} />}
                <Popover
                  visible={popOverclicked}
                  placement="topLeft"
                  content={() => {
                    return (
                      <RangePicker
                        picker="date"
                        size="small"
                        onChange={(range: any) => {
                          rangeChange(range);
                        }}
                        format={defaultDateFormat}
                        ranges={{
                          Today: [moment(), moment()],
                          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                          "Last 2 days": [moment().subtract(2, "days"), moment()],
                          "Last 7 days": [moment().subtract(7, "days"), moment()],
                        }}
                        dropdownClassName="filter-date-picker"
                        autoFocus={true}
                        onCalendarChange={(newDates) => {
                          if (newDates === null) {
                            setDateFilterApplied(false);
                          }
                        }}
                        value={filterStartDate && filterEndDate ? [moment(moment(filterStartDate).format(defaultDateFormat)), moment(moment(filterEndDate).format(defaultDateFormat))] : undefined}
                        onOpenChange={(state) => {
                          handlePopOverClose(state);
                        }}
                      />
                    );
                  }}
                >
                  <Badge dot={isDateFilterApplied} offset={[-2, 0]}>
                    <i className="icon-filter noteDrawer-action" onClick={() => setPopOverClicked(!popOverclicked)} />
                  </Badge>
                </Popover>
                {(searchValue || (filterStartDate && filterEndDate)) && (
                  <CustomTooltip
                    toolTipvalue={"Clear Filters"}
                    children={
                      <span className="noteDrawer-action icon-filter-reset" onClick={resetNotesFilter}>
                        <Icon name="reset-filter" />
                      </span>
                    }
                  />
                )}
                {selectedDrawerOption === "Notes" && defaultTab === "2" && centricClientCheck() ? (
                  <Tooltip
                    title={
                      notesData?.allNotesTotalCount <= 0 ? (
                        <>
                          No Data <br /> Available
                        </>
                      ) : isMemberDetails ? (
                        <>
                          Download <br /> All Notes
                        </>
                      ) : (
                        <>
                          Download <br /> Your Notes
                        </>
                      )
                    }
                  >
                    <div
                      className={`noteDrawer-${notesData?.allNotesTotalCount > 0 ? "action" : "no-action"}`}
                      onClick={!downloadLoader && notesData?.allNotesTotalCount > 0 ? downloadNotesReport : undefined}
                    >
                      <Spinner loading={downloadLoader} size={20}>
                        <DownloadOutlined />
                      </Spinner>
                    </div>
                  </Tooltip>
                ) : null}
              </>
            )}
            {isOutreachSelected && (
              <>
                {!showSearchBox && <i className="icon icon-search noteDrawer-action" onClick={openSearch} />}
                <Badge dot={isGlobalEntryFilterApplied}>
                  <i className="icon-filter noteDrawer-action" onClick={() => setShowEntryFilter((prev) => !prev)} />
                </Badge>
                {(searchValue || isGlobalEntryFilterApplied) && (
                  <CustomTooltip
                    toolTipvalue={"Clear Filters"}
                    children={
                      <span className="noteDrawer-action icon-filter-reset" onClick={resetOutreachesFilter}>
                        <Icon name="reset-filter" />
                      </span>
                    }
                  />
                )}
              </>
            )}
            {isNotificationSelected && (
              <>
                {!showSearchBox && <i className="icon icon-search noteDrawer-action" onClick={openSearch} />}
                <Dropdown overlay={notificationDrawerFilterOptions} trigger={["click"]}>
                  <Badge dot={datefilter !== "all"}>
                    <i className="icon-filter noteDrawer-action" onClick={(e) => e.preventDefault()} />
                  </Badge>
                </Dropdown>
                {(searchValue || datefilter) && (
                  <CustomTooltip
                    toolTipvalue={"Clear Filters"}
                    children={
                      <span className="noteDrawer-action icon-filter-reset" onClick={resetNotificationFilter}>
                        <Icon name="reset-filter" />
                      </span>
                    }
                  />
                )}
              </>
            )}
            <i className="icon-close noteDrawer-action" onClick={rightDrawerCloseHandler} />
          </>
        }
      >
        {milleniumClientCheck() && get(selectedDrawer, "canExpand", false) && (
          <CustomTooltip toolTipvalue={sidebarExpand ? "Close Calendar" : "Open Calendar"}>
            <span className={`calender-btn--expand`} onClick={() => handleSidebar(sidebarExpand ? false : true)}>
              <Icon name={`${sidebarExpand ? "right" : "left"}-collapse-icon`} />
            </span>
          </CustomTooltip>
        )}
        <Wrapper
          children={
            <DrawerContent
              {...{
                selectedDrawerOption,
                members,
                updateMembers,
                searchValue,
                filterValue,
                filterStartDate,
                filterEndDate,
                showRightActionBar,
                updateStatus,
                rightDrawerCloseHandler,
                globalEntryFilterData,
                fetchOutReaches,
                setOutReachesData,
                outReachesLoader,
                outReachesData,
                datefilter,
                defaultTab,
                setDefaultTab,
              }}
            />
          }
        />
        {showEntryFilter && (
          <EntryFilter
            searchValue={searchValue}
            fetchOutReaches={fetchOutReaches}
            showFilter={setShowEntryFilter}
            globalEntryFilterData={globalEntryFilterData}
            setGlobalEntryFilterData={setGlobalEntryFilterData}
          />
        )}
      </Drawer>
      <CmContactMatrixModalReadMode />
      <ScrollToTopButton />
      </CadenceContextProvider>
    </>
  );
};

export default Layout;

const Wrapper: React.FC<any> = function ({children}) {
  return (
    <RemindersProvider>
      {children}
    </RemindersProvider>
  )
};

